// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BreachMonitorPage__root--P8zy {
    display: grid;
    grid-template-rows: max-content max-content max-content;
    grid-template-areas: "mainSection"
                        "breachInstructions"
                        "breachesInformation";
    grid-gap: 24px;
}
    
    @media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {.BreachMonitorPage__root--P8zy {
        grid-template-columns: 632px auto;
        grid-template-rows: 188px auto;
        grid-template-areas: "mainSection breachInstructions"
                        "breachesInformation breachInstructions"
}
    }

.BreachMonitorPage__section--XOLM {
    padding: 20px;
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
    grid-area: mainSection;
}

.BreachMonitorPage__breachesInformation--hqYg {
    grid-area: breachesInformation;
}

.BreachMonitorPage__breachInstructions--Mecj {
    width: 100%;
    padding: 20px;
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
    grid-area: breachInstructions;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: -moz-max-content;
    height: max-content;
}

@media screen and (max-width: 518px) {
        .BreachMonitorPage__breachInstructions--Mecj .BreachMonitorPage__breachInstructionsList--mLfO {
            display: none;
        }

        .BreachMonitorPage__breachInstructions--Mecj.BreachMonitorPage__visibleOnMobile--gmqH .BreachMonitorPage__breachInstructionsList--mLfO {
            display: flex;
        }
            .BreachMonitorPage__breachInstructions--Mecj:not(.BreachMonitorPage__visibleOnMobile--gmqH) .BreachMonitorPage__icon--Ue7h {
                transform: rotate(-180deg);
            }
    }

.BreachMonitorPage__breachInstructionsWrapper--CRh0 {
    display: grid;
    grid-template-columns: auto 40px;
    grid-gap: 6px;
    align-items: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.BreachMonitorPage__breachInstructionsWrapper--CRh0 {
        display: block;
        pointer-events: none
}

        .BreachMonitorPage__breachInstructionsWrapper--CRh0 .BreachMonitorPage__iconWrapper--S5Z9 {
            display: none;
        }
    }

.BreachMonitorPage__breachInstructionsTitle--owg0 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: var(--darkest-color);
}

.BreachMonitorPage__iconWrapper--S5Z9 {
    border: 1px solid var(--obscure-color);
    padding: 11px;
    border-radius: 6px;
    height: 40px;
    display: flex;
    align-items: center;
}

.BreachMonitorPage__icon--Ue7h {
    width: 16px;
    height: 16px;
    color: var(--secondary-color);
    transition: 0.25s ease-in-out transform;
}

.BreachMonitorPage__breachInstructionsList--mLfO {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: var(--secondary-color);
}

.BreachMonitorPage__breachInstructionsList--mLfO > li > span {
        font-weight: 700;
        display: block;
        margin-bottom: 12px;
    }

.BreachMonitorPage__sectionWithWarning--wENG {
    border-color: var(--warning-color);
}

.BreachMonitorPage__emailInformation--Fr5J {
    display: grid;
    grid-template-columns: 16px auto;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 26px;
    line-height: 34px;
    color: var(--darkest-color);
    margin-bottom: 24px;
}

.BreachMonitorPage__emailInformation--Fr5J > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
    }

.BreachMonitorPage__emailInformation--Fr5J > svg {
        width: 16px;
        height: 16px;
        color: var(--gray-color);
    }

.BreachMonitorPage__breachDetails--AKbS {
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap: 12px;
    margin-bottom: 12px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.BreachMonitorPage__breachDetails--AKbS {
        grid-gap: 24px;
        grid-template-columns: max-content max-content
}
    }

.BreachMonitorPage__breachDetailsItem--alsL {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: var(--secondary-color);
}

.BreachMonitorPage__breachDetailsItem--alsL > span:first-child {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
    }

.BreachMonitorPage__breachDetailsItem--alsL > span:last-child {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
    }

.BreachMonitorPage__secondaryTitle--UIzW {
    margin-bottom: 4px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: var(--darkest-color);
}

.BreachMonitorPage__description--P7P1 {
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: var(--darkest-color);
    margin-bottom: 24px;
}

.BreachMonitorPage__description--P7P1 > strong {
        font-weight: 700;
    }

.BreachMonitorPage__breachList--j3fc {
    display: flex;
    flex-direction: column;
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
}

.BreachMonitorPage__breachItem--ppPm {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.BreachMonitorPage__breachItem--ppPm:not(:last-child) {
        border-bottom: 1px solid var(--obscure-color);
    }

.BreachMonitorPage__breachItem--ppPm.BreachMonitorPage__resolved--dV20 .BreachMonitorPage__breachItemWrapper--rtsA > img {
            opacity: 0.5;
        }

.BreachMonitorPage__breachItem--ppPm.BreachMonitorPage__resolved--dV20 .BreachMonitorPage__breachItemWrapper--rtsA > span {
            color: var(--gray-color);
        }

.BreachMonitorPage__breachItemHeader--oeck {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

@media screen and (max-width: 518px) {
        .BreachMonitorPage__breachItemHeader--oeck > label {
            margin-left: auto;
        }
    }

.BreachMonitorPage__toggleSwitcherWrapper--bVkZ {
    display: flex;
    align-items: center;
    gap: 8px;
}

@media screen and (max-width: 518px) {

.BreachMonitorPage__toggleSwitcherWrapper--bVkZ {
        margin-left: auto
}
    }

.BreachMonitorPage__toggleSwitcherLabel--StPS {
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--secondary-color);
}

.BreachMonitorPage__breachItemWrapper--rtsA {
    display: grid;
    grid-template-columns: 48px auto;
    align-items: center;
    grid-gap: 12px;
}

.BreachMonitorPage__breachItemWrapper--rtsA > img {
        width: 48px;
        height: 48px;
        padding: 12px;
        border-radius: 6px;
        background-color: #B8BFD2;
        display: block;
        -o-object-fit: contain;
           object-fit: contain;
        -o-object-position: center;
           object-position: center;
        transition: opacity 0.4s linear;
    }

.BreachMonitorPage__breachItemWrapper--rtsA > span {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: var(--darkest-color);
        transition: color 0.4s linear;
    }

.BreachMonitorPage__breachItemDescription--gTjZ {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: var(--secondary-color);
}

.BreachMonitorPage__breachItemDescription--gTjZ > a {
        text-decoration: underline;
        color: var(--secondary-color);
    }

.BreachMonitorPage__compromisedList--v99F {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.BreachMonitorPage__compromisedListTitle--rp8v {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: var(--secondary-color);
}

.BreachMonitorPage__compromisedListItem--qHGa {
    background: #545F921A;
    border-radius: 28px;
    padding: 4px 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: var(--secondary-color);
}

.BreachMonitorPage__loader--c334 {
    display: block;
    margin: 40px auto;
}

.BreachMonitorPage__noteBlock--zWEd {
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
    padding: 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: var(--secondary-color);
}

.BreachMonitorPage__noteBlock--zWEd > strong {
        font-weight: 700;
    }
`, "",{"version":3,"sources":["webpack://./src/ui/pages/BreachMonitorPage/BreachMonitorPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uDAAuD;IACvD;;6CAEyC;IACzC,cAAc;AAQlB;;IANI,8FARJ;QASQ,iCAAiC;QACjC,8BAA8B;QAC9B;;AAGR;IADI;;AAGJ;IACI,aAAa;IACb,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,wBAAmB;IAAnB,mBAAmB;AAiBvB;;AAfI;QACI;YACI,aAAa;QACjB;;QAEA;YACI,aAAa;QACjB;YAGI;gBACI,0BAA0B;YAC9B;IAER;;AAGJ;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,wCAAwC;AAU5C;;AARI;;AARJ;QASQ,cAAc;QACd;AAMR;;QAJQ;YACI,aAAa;QACjB;IACJ;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AAOjC;;AALI;QACI,gBAAgB;QAChB,cAAc;QACd,mBAAmB;IACvB;;AAGJ;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AAcvB;;AAZI;QACI,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;IACzB;;AAEA;QACI,WAAW;QACX,YAAY;QACZ,wBAAwB;IAC5B;;AAGJ;IACI,aAAa;IACb,uCAAuC;IACvC,cAAc;IACd,mBAAmB;AAMvB;;AAJI;;AANJ;QAOQ,cAAc;QACd;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;AAajC;;AAXI;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAGJ;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AAKvB;;AAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AAeb;;AAbI;QACI,6CAA6C;IACjD;;AAGI;YACI,YAAY;QAChB;;AAEA;YACI,wBAAwB;QAC5B;;AAIR;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AAOb;;AALI;QACI;YACI,iBAAiB;QACrB;IACJ;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AAKZ;;AAHI;;AALJ;QAMQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAqBlB;;AAnBI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,yBAAyB;QACzB,cAAc;QACd,sBAAmB;WAAnB,mBAAmB;QACnB,0BAAuB;WAAvB,uBAAuB;QACvB,+BAA+B;IACnC;;AAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,2BAA2B;QAC3B,6BAA6B;IACjC;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AAMjC;;AAJI;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AAKjC;;AAHI;QACI,gBAAgB;IACpB","sourcesContent":[".root {\n    display: grid;\n    grid-template-rows: max-content max-content max-content;\n    grid-template-areas: \"mainSection\"\n                        \"breachInstructions\"\n                        \"breachesInformation\";\n    grid-gap: 24px;\n    \n    @media (--large), (--small-tablet) {\n        grid-template-columns: 632px auto;\n        grid-template-rows: 188px auto;\n        grid-template-areas: \"mainSection breachInstructions\"\n                        \"breachesInformation breachInstructions\";\n    }\n}\n\n.section {\n    padding: 20px;\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n    grid-area: mainSection;\n}\n\n.breachesInformation {\n    grid-area: breachesInformation;\n}\n\n.breachInstructions {\n    width: 100%;\n    padding: 20px;\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n    grid-area: breachInstructions;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    height: max-content;\n\n    @media (--tiny-only) {\n        .breachInstructionsList {\n            display: none;\n        }\n\n        &.visibleOnMobile .breachInstructionsList {\n            display: flex;\n        }\n\n        &:not(.visibleOnMobile) {\n            .icon {\n                transform: rotate(-180deg);\n            }\n        }\n    }\n}\n\n.breachInstructionsWrapper {\n    display: grid;\n    grid-template-columns: auto 40px;\n    grid-gap: 6px;\n    align-items: center;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n\n    @media (--large), (--small-tablet) {\n        display: block;\n        pointer-events: none;\n\n        .iconWrapper {\n            display: none;\n        }\n    }\n}\n\n.breachInstructionsTitle {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n    color: var(--darkest-color);\n}\n\n.iconWrapper {\n    border: 1px solid var(--obscure-color);\n    padding: 11px;\n    border-radius: 6px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n}\n\n.icon {\n    width: 16px;\n    height: 16px;\n    color: var(--secondary-color);\n    transition: 0.25s ease-in-out transform;\n}\n\n.breachInstructionsList {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    color: var(--secondary-color);\n\n    > li > span {\n        font-weight: 700;\n        display: block;\n        margin-bottom: 12px;\n    }\n}\n\n.sectionWithWarning {\n    border-color: var(--warning-color);\n}\n\n.emailInformation {\n    display: grid;\n    grid-template-columns: 16px auto;\n    align-items: center;\n    gap: 8px;\n    font-weight: 700;\n    font-size: 26px;\n    line-height: 34px;\n    color: var(--darkest-color);\n    margin-bottom: 24px;\n\n    > span {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        display: inline-block;\n    }\n\n    > svg {\n        width: 16px;\n        height: 16px;\n        color: var(--gray-color);\n    }\n}\n\n.breachDetails {\n    display: grid;\n    grid-template-columns: auto max-content;\n    grid-gap: 12px;\n    margin-bottom: 12px;\n\n    @media (--large), (--small-tablet) {\n        grid-gap: 24px;\n        grid-template-columns: max-content max-content;\n    }\n}\n\n.breachDetailsItem {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    color: var(--secondary-color);\n\n    > span:first-child {\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 20px;\n    }\n\n    > span:last-child {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 32px;\n    }\n}\n\n.secondaryTitle {\n    margin-bottom: 4px;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    color: var(--darkest-color);\n}\n\n.description {\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 400;\n    color: var(--darkest-color);\n    margin-bottom: 24px;\n\n    > strong {\n        font-weight: 700;\n    }\n}\n\n.breachList {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n}\n\n.breachItem {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    &:not(:last-child) {\n        border-bottom: 1px solid var(--obscure-color);\n    }\n\n    &.resolved {\n        .breachItemWrapper > img {\n            opacity: 0.5;\n        }\n\n        .breachItemWrapper > span {\n            color: var(--gray-color);\n        }\n    }\n}\n\n.breachItemHeader {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n\n    @media (--tiny-only) {\n        > label {\n            margin-left: auto;\n        }\n    }\n}\n\n.toggleSwitcherWrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    @media (--tiny-only) {\n        margin-left: auto;\n    }\n}\n\n.toggleSwitcherLabel {\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--secondary-color);\n}\n\n.breachItemWrapper {\n    display: grid;\n    grid-template-columns: 48px auto;\n    align-items: center;\n    grid-gap: 12px;\n\n    > img {\n        width: 48px;\n        height: 48px;\n        padding: 12px;\n        border-radius: 6px;\n        background-color: #B8BFD2;\n        display: block;\n        object-fit: contain;\n        object-position: center;\n        transition: opacity 0.4s linear;\n    }\n\n    > span {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 24px;\n        color: var(--darkest-color);\n        transition: color 0.4s linear;\n    }\n}\n\n.breachItemDescription {\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    color: var(--secondary-color);\n\n    > a {\n        text-decoration: underline;\n        color: var(--secondary-color);\n    }\n}\n\n.compromisedList {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.compromisedListTitle {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: var(--secondary-color);\n}\n\n.compromisedListItem {\n    background: #545F921A;\n    border-radius: 28px;\n    padding: 4px 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: var(--secondary-color);\n}\n\n.loader {\n    display: block;\n    margin: 40px auto;\n}\n\n.noteBlock {\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n    padding: 20px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: var(--secondary-color);\n\n    > strong {\n        font-weight: 700;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BreachMonitorPage__root--P8zy`,
	"section": `BreachMonitorPage__section--XOLM`,
	"breachesInformation": `BreachMonitorPage__breachesInformation--hqYg`,
	"breachInstructions": `BreachMonitorPage__breachInstructions--Mecj`,
	"breachInstructionsList": `BreachMonitorPage__breachInstructionsList--mLfO`,
	"visibleOnMobile": `BreachMonitorPage__visibleOnMobile--gmqH`,
	"icon": `BreachMonitorPage__icon--Ue7h`,
	"breachInstructionsWrapper": `BreachMonitorPage__breachInstructionsWrapper--CRh0`,
	"iconWrapper": `BreachMonitorPage__iconWrapper--S5Z9`,
	"breachInstructionsTitle": `BreachMonitorPage__breachInstructionsTitle--owg0`,
	"sectionWithWarning": `BreachMonitorPage__sectionWithWarning--wENG`,
	"emailInformation": `BreachMonitorPage__emailInformation--Fr5J`,
	"breachDetails": `BreachMonitorPage__breachDetails--AKbS`,
	"breachDetailsItem": `BreachMonitorPage__breachDetailsItem--alsL`,
	"secondaryTitle": `BreachMonitorPage__secondaryTitle--UIzW`,
	"description": `BreachMonitorPage__description--P7P1`,
	"breachList": `BreachMonitorPage__breachList--j3fc`,
	"breachItem": `BreachMonitorPage__breachItem--ppPm`,
	"resolved": `BreachMonitorPage__resolved--dV20`,
	"breachItemWrapper": `BreachMonitorPage__breachItemWrapper--rtsA`,
	"breachItemHeader": `BreachMonitorPage__breachItemHeader--oeck`,
	"toggleSwitcherWrapper": `BreachMonitorPage__toggleSwitcherWrapper--bVkZ`,
	"toggleSwitcherLabel": `BreachMonitorPage__toggleSwitcherLabel--StPS`,
	"breachItemDescription": `BreachMonitorPage__breachItemDescription--gTjZ`,
	"compromisedList": `BreachMonitorPage__compromisedList--v99F`,
	"compromisedListTitle": `BreachMonitorPage__compromisedListTitle--rp8v`,
	"compromisedListItem": `BreachMonitorPage__compromisedListItem--qHGa`,
	"loader": `BreachMonitorPage__loader--c334`,
	"noteBlock": `BreachMonitorPage__noteBlock--zWEd`
};
export default ___CSS_LOADER_EXPORT___;
